import React, { JSX } from "react";
import { useQuery } from "@apollo/client/react";

import { NEW_PROJECT_QUERY } from "queries/newProject";

import Project from "./project";
import { useEffect } from "react";
import { useLocation } from "wouter";
import { Employee, GetNewProjectQuery, NewProject } from "generated/graphql";

const NewProjectShell = ({
  id,
  accountingId,
  archivedProjectId,
  tab,
}: {
  id?: string;
  accountingId?: string;
  archivedProjectId?: string;
  tab?: string;
}): JSX.Element => {
  const { data, loading } = useQuery<GetNewProjectQuery>(NEW_PROJECT_QUERY, {
    variables: { id, accountingId, archivedProjectId },
  });
  const [_location, navigate] = useLocation();
  const params: { tab?: string } = { tab };
  const loadedId = id ?? (data?.newProject as Partial<NewProject>)?.id;

  useEffect(() => {
    if (!id && (accountingId || archivedProjectId) && loadedId) {
      const tab = params.tab ? `/${params.tab}` : "";
      navigate(`/project/${loadedId}${tab}`, { replace: true });
    }
  }, [loadedId]);

  return (
    <Project
      id={loadedId ?? ""}
      project={data?.newProject as Partial<NewProject>}
      loading={loading}
      currentEmployee={data?.me as Partial<Employee>}
      tab={tab}
    />
  );
};

export default NewProjectShell;
